import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getCentralizedModulesDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedModules: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Airport Label",
      fieldValue: "myairports_airport_label",
      className: "col-span-6",
      type: "text",
      name: "myairports_airport_label",
      formType: "input",
      label: "Airport Label",
      placeholder: "Airport Label",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "MyAirports Latitude",
      fieldValue: "latitude",
      className: "col-span-6",
      type: "text",
      name: "latitude",
      formType: "input",
      label: "MyAirports Latitude",
      placeholder: "MyAirports Latitude",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "MyAirports Longitude",
      fieldValue: "longitude",
      className: "col-span-6",
      type: "text",
      name: "longitude",
      formType: "input",
      label: "MyAirports Longitude",
      placeholder: "MyAirports Longitude",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "MyAirports Radius",
      fieldValue: "radius",
      className: "col-span-6",
      type: "text",
      name: "radius",
      formType: "input",
      label: "MyAirports Radius",
      placeholder: "MyAirports Radius",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
